/**
 * Video Section Schema
 * Schema-driven settings with conditional visibility
 */
export default {
  id: 'video',
  version: 1,
  title: 'Видео',
  description: 'Блок с видео из YouTube, VK Video или RuTube',
  icon: 'Play',
  category: 'media',

  fields: [
    {
      group: 'Компоновка',
      fields: [
        {
          key: 'layout',
          type: 'select',
          label: 'Вариант отображения',
          mode: 'grid',
          columns: 3,
          options: [
            { value: 'centered', label: 'По центру', icon: 'AlignCenter' },
            { value: 'split', label: 'С текстом', icon: 'Columns2' },
            { value: 'lightbox', label: 'Lightbox', icon: 'Play' }
          ]
        }
      ]
    },
    {
      group: 'Видео',
      fields: [
        {
          key: 'videoUrl',
          type: 'input',
          label: 'Ссылка на видео',
          placeholder: 'https://youtube.com/watch?v=... или VK/RuTube',
          hint: 'Поддерживается: YouTube, VK Video (код встраивания), RuTube'
        },
        {
          key: 'posterImage',
          type: 'image',
          label: 'Превью изображение',
          visible: (data) => data?.layout === 'lightbox',
          hint: 'Если не указано, используется автоматическое превью (для YouTube)'
        },
        {
          key: 'aspectRatio',
          type: 'select',
          label: 'Соотношение сторон',
          options: [
            { value: '16:9', label: '16:9 (стандарт)' },
            { value: '4:3', label: '4:3' },
            { value: '1:1', label: '1:1 (квадрат)' },
            { value: '9:16', label: '9:16 (вертикальное)' }
          ]
        },
        {
          key: 'maxWidth',
          type: 'select',
          label: 'Максимальная ширина',
          visible: (data) => data?.layout === 'centered' || data?.layout === 'lightbox',
          options: [
            { value: 'small', label: 'Маленькая (640px)' },
            { value: 'medium', label: 'Средняя (854px)' },
            { value: 'large', label: 'Большая (1024px)' },
            { value: 'full', label: 'Во всю ширину' }
          ]
        },
        {
          key: 'videoPosition',
          type: 'select',
          label: 'Позиция видео',
          visible: (data) => data?.layout === 'split',
          options: [
            { value: 'left', label: 'Слева' },
            { value: 'right', label: 'Справа' }
          ]
        }
      ]
    },
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Заголовок блока',
          defaults: { size: '3xl', weight: 'bold', color: 'inherit' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Описание',
          placeholder: 'Описание или подзаголовок',
          multiline: true,
          rows: 3,
          defaults: { size: 'lg', weight: 'normal', color: 'secondary' }
        }
      ]
    },
    {
      group: 'Воспроизведение',
      visible: (data) => data?.layout !== 'lightbox',
      fields: [
        {
          key: 'autoplay',
          type: 'checkbox',
          label: 'Автовоспроизведение (без звука)'
        },
        {
          key: 'loop',
          type: 'checkbox',
          label: 'Зациклить'
        }
      ]
    },
    {
      group: 'Кнопки',
      visible: (data) => data?.layout === 'split',
      fields: [
        {
          key: 'buttons',
          type: 'buttonList',
          label: 'Кнопки действий',
          variants: ['primary', 'secondary', 'outline']
        }
      ]
    }
  ],

  default: {
    layout: 'centered',
    videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
    title: { text: 'Посмотрите видео' },
    subtitle: { text: 'Узнайте больше о нашем продукте из этого короткого ролика' },
    videoPosition: 'left',
    aspectRatio: '16:9',
    maxWidth: 'large',
    autoplay: false,
    loop: false,
    buttons: []
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      // Convert old text formats to new
      const migrated = { ...this.default, ...data };
      if (typeof migrated.title === 'string') {
        migrated.title = { text: migrated.title };
      }
      if (typeof migrated.subtitle === 'string') {
        migrated.subtitle = { text: migrated.subtitle };
      }
      return migrated;
    }
    return data;
  }
};
